import { render, staticRenderFns } from "./SetNotarPrice.vue?vue&type=template&id=515e1c86"
import script from "./SetNotarPrice.vue?vue&type=script&lang=js"
export * from "./SetNotarPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports